import { render, staticRenderFns } from "./DepositReceiveEdit.vue?vue&type=template&id=31d60568&scoped=true"
import script from "./DepositReceiveEdit.vue?vue&type=script&lang=js"
export * from "./DepositReceiveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d60568",
  null
  
)

export default component.exports